export default __webpack_public_path__ + "static/media/5.35c2d05f.jpg";